package com.arena_web.data.repository

import com.arena_web.data.api.SportApi
import com.arena_web.data.dto.*
import com.arena_web.domain.repositories.SportRepository

class SportRepositoryImpl(private val sportApi: SportApi) : SportRepository {

    override suspend fun getAllSports(): Result<List<SportDto>> =
        apiCall { sportApi.getAllSports() }

    override suspend fun getAttributes(sportId: String): Result<List<SportAttributeDto>> =
        apiCall { sportApi.getAttributes(sportId) }

    override suspend fun getPositions(sportId: String): Result<List<SportPositionDto>> =
        apiCall { sportApi.getPositions(sportId) }

    override suspend fun getStatTypes(sportId: String): Result<List<SportStatTypeDto>> =
        apiCall { sportApi.getStatTypes(sportId) }

    override suspend fun getFormations(sportId: String): Result<List<FormationDto>> =
        apiCall { sportApi.getFormations(sportId) }
}
